<template>
  <FilterBase label="Search">
    <GenericSearchInput
      label="Search Community content"
      background="white"
      :full-width="true"
      :single-line="true"
      :padding="true"
      :outlined="true"
      :white-background="true"
      @search="onSearch"
    ></GenericSearchInput>
  </FilterBase>
</template>

<script>
import FilterBase from "~/components/communities/components/FilterBase.vue";
import GenericSearchInput from "~/components/search/GenericSearchInput";

export default {
  name: "CommunityContentSearch",
  components: {
    FilterBase,
    GenericSearchInput,
  },
  methods: {
    onSearch(searchTerm) {
      this.$emit("search", searchTerm);
    },
  },
};
</script>
